// Quality control

page.f.qualityUpdate = function(){
    var v = page.v.quality;
    var res = v.resolution * page.three.renderer.getPixelRatio();
    if(page.three.banga){
        page.three.banga.material.uniforms.uQlt.value = v.banga;
        page.three.banga.material.uniforms.uRes.value = res;
    }
    if(page.three.tree){
        page.three.tree.material.uniforms.uQlt.value = v.medis_kotas;
        page.three.tree.material.uniforms.uQlt2.value = v.medis_lapai;
        page.three.tree.material.uniforms.uRes.value = res;
    }

    var sides = page.v.quality.loader;

    page.three.transition.geometry.dispose();
    page.three.transGeo = new THREE.PlaneBufferGeometry( 1, 1, sides, sides );
    page.three.transition.geomtery = page.three.transGeo;
    page.three.transition.material.uniforms.uRes.value = res;

    page.three.resize();

}